// Program data for the landing page

export const RAZORPAY_PAYMENT_LINK = "https://rzp.io/rzp/j10Inl3m";

export const programData = {
  title: "Advanced Financial Markets Program",
  subtitle: "For Teenagers (13–17 Years)",
  cohortInfo: "Limited 20-Seat Cohort | Parent Orientation Required",
  
  orientationDetails: {
    fee: 299,
    currency: "INR",
    seatsAvailable: 20,
    date: "Sunday, 21 June 2026",
    time: "5:00 PM – 6:30 PM IST",
    duration: "90 minutes",
    format: "Live Online (Zoom link shared after registration)",
    recordingNote: "Session recording will be shared with registered parents in case of unavoidable absence."
  },

  programFormat: {
    duration: "10 Weeks",
    sessions: 20,
    schedule: "Saturday & Sunday",
    timing: "3:00 PM – 4:00 PM IST",
    format: "Live Interactive Sessions",
    capacity: "Limited to 20 Students"
  },

  learningOutcomes: [
    "Market structure fundamentals and how financial systems operate",
    "Risk-reward logic and probability-based thinking",
    "Asset allocation basics and portfolio construction principles",
    "Behavioral biases and psychological factors in decision-making",
    "Capital preservation mindset and risk management strategies"
  ],

  problemPoints: [
    "Schools do not teach financial systems or market literacy",
    "Most young adults enter college without practical money management skills",
    "Trading apps allow execution but do not teach disciplined thinking"
  ],

  programClarifications: {
    whatItIs: [
      "Structured educational program with institutional rigor",
      "Emphasis on risk management and capital protection",
      "Focus on long-term thinking and systematic decision-making",
      "Foundation in financial literacy and market understanding"
    ],
    whatItIsNot: [
      "Not gambling or speculation coaching",
      "Not intraday trading tips or shortcuts",
      "Not get-rich-quick schemes",
      "Not investment advice or stock recommendations"
    ]
  },

  targetAudience: [
    "Academically serious teenagers aged 13–17",
    "Parents who value structured education and future readiness",
    "Families seeking to build financial thinking skills early",
    "Students interested in understanding economic systems"
  ]
};
